import React from 'react'
import LinkList from './LinkList'
import SingleLink from './SingleLink'

const DesktopLink = ({
  link,
  setIsBespokeOpen,
  isBespokeOpen,
  activeTab,
  setActiveTab
}) => {
  const handleBespokeFormPopup = () => {
    if (!isBespokeOpen) {
      setIsBespokeOpen(true)
    }
  }
  switch (link.__typename) {
    case "ContentfulLink":
      return (
        <SingleLink
          link={link}
          handleBespokeFormPopup={handleBespokeFormPopup}
          setActiveTab={setActiveTab}
          activeTab={activeTab}
        />
      )
    case "ContentfulLinkList":
      return (
        <LinkList
          link={link}
          setActiveTab={setActiveTab}
          activeTab={activeTab}
        />
      )
    default:
      return null
  }
}

export default DesktopLink
